import {ActionReducer, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromBrand from '../reducers/brand.reducer';
import {combineReducers} from '@ngrx/store';
import {AppState} from '../../../store/reducers/index';

export interface BrandsState {
  brands: fromBrand.BrandState;
}

export const reducers: ActionReducerMap<BrandsState> = {
  brands: fromBrand.reducer,
};

export const reducer: ActionReducer<BrandsState> = combineReducers(reducers);

export const getBrandsState = createFeatureSelector<BrandsState>('brandsFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/brands/store/reducers/index.ts